export default __webpack_public_path__ + "static/media/company.fc0a1b0f.jpg";